const SESSION_TOKEN_KEY = "session_token";
const USER_DATA_KEY = "user_data";
const AUTO_LOGOUT_MINUTES_KEY = "auto_logout_minutes";
const LAST_ACTIVITY_AT_KEY = "session_last_activity_at";
const LOGOUT_REASON_KEY = "session_logout_reason";

const DEFAULT_AUTO_LOGOUT_MINUTES = 30;
const IDLE_CHECK_INTERVAL_MS = 15000;

const ACTIVITY_EVENTS = [
  "click",
  "mousemove",
  "mousedown",
  "keydown",
  "scroll",
  "touchstart",
];

let monitorStarted = false;
let monitorIntervalId = null;
let logoutInProgress = false;

const getSessionToken = () => (localStorage.getItem(SESSION_TOKEN_KEY) || "").trim();

const hasActiveSession = () => {
  const token = getSessionToken();
  const userData = localStorage.getItem(USER_DATA_KEY);
  return Boolean(token && userData);
};

export const getAutoLogoutMinutes = () => {
  const raw = localStorage.getItem(AUTO_LOGOUT_MINUTES_KEY);
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0
    ? parsed
    : DEFAULT_AUTO_LOGOUT_MINUTES;
};

export const markSessionActivity = () => {
  if (!hasActiveSession()) return;
  localStorage.setItem(LAST_ACTIVITY_AT_KEY, String(Date.now()));
};

const clearSessionData = () => {
  localStorage.removeItem(SESSION_TOKEN_KEY);
  localStorage.removeItem(USER_DATA_KEY);
  localStorage.removeItem(AUTO_LOGOUT_MINUTES_KEY);
  localStorage.removeItem(LAST_ACTIVITY_AT_KEY);
};

const notifyServerLogout = async (token) => {
  if (!token) return;

  try {
    await fetch("https://newerp.awasthivitality.com/api/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "X-Session-Token": token,
      },
      keepalive: true,
    });
  } catch (error) {
    // Silent fallback: local cleanup + redirect still continue.
  }
};

export const forceLogoutToLogin = async (reason = "idle_timeout") => {
  if (logoutInProgress) return;
  logoutInProgress = true;

  const token = getSessionToken();
  await notifyServerLogout(token);

  clearSessionData();
  sessionStorage.setItem(LOGOUT_REASON_KEY, reason);

  if (window.location.pathname !== "/") {
    window.location.replace("/");
  }
};

const handleUserActivity = () => {
  markSessionActivity();
};

const checkIdleTimeout = () => {
  if (!hasActiveSession()) return;

  const timeoutMs = getAutoLogoutMinutes() * 60 * 1000;
  const nowTs = Date.now();

  const lastActivityRaw = localStorage.getItem(LAST_ACTIVITY_AT_KEY);
  const lastActivityAt = Number(lastActivityRaw);

  if (!Number.isFinite(lastActivityAt) || lastActivityAt <= 0) {
    localStorage.setItem(LAST_ACTIVITY_AT_KEY, String(nowTs));
    return;
  }

  if (nowTs - lastActivityAt >= timeoutMs) {
    forceLogoutToLogin("idle_timeout");
  }
};

export const startSessionIdleMonitor = () => {
  if (monitorStarted) return;
  monitorStarted = true;
  logoutInProgress = false;

  ACTIVITY_EVENTS.forEach((eventName) => {
    window.addEventListener(eventName, handleUserActivity, { passive: true });
  });

  checkIdleTimeout();
  monitorIntervalId = window.setInterval(checkIdleTimeout, IDLE_CHECK_INTERVAL_MS);
};

export const stopSessionIdleMonitor = () => {
  if (!monitorStarted) return;
  monitorStarted = false;

  ACTIVITY_EVENTS.forEach((eventName) => {
    window.removeEventListener(eventName, handleUserActivity);
  });

  if (monitorIntervalId) {
    window.clearInterval(monitorIntervalId);
    monitorIntervalId = null;
  }
};